module.exports = __webpack_public_path__ + "static/media/indesign.adc702af.png";